import { render, staticRenderFns } from "./dictAdd.vue?vue&type=template&id=bdf0ee64&scoped=true"
import script from "./dictAdd.vue?vue&type=script&lang=js"
export * from "./dictAdd.vue?vue&type=script&lang=js"
import style0 from "./dictAdd.vue?vue&type=style&index=0&id=bdf0ee64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf0ee64",
  null
  
)

export default component.exports